import { User } from "../Role_Layout/roleTypes";

export function employeeIdError(
	employeeId: string,
	users: User[],
	currentId?: string
) {
	if (!employeeId) {
		return 'Employee ID is required.';
	}

	// 7️ Trim spaces & 5️ convert to uppercase
	const normalizedId = employeeId.trim().toUpperCase();

	// 1️ Mandatory check (after trim)
	if (!normalizedId) {
		return 'Employee ID is required.';
	}

	// 2️ Allowed characters: only letters & numbers (no spaces, no special chars)
	const alphaNumericRegex = /^[A-Z0-9]+$/;
	if (!alphaNumericRegex.test(normalizedId)) {
		return 'Employee ID can contain only letters and numbers.';
	}

	// 3️ Length validation
	if (normalizedId.length < 3 || normalizedId.length > 15) {
		return 'Employee ID must be between 3 and 15 characters.';
	}

	// 6 Uniqueness check
	const isDuplicate = users.some(
		(item) =>
			item.employeeId?.toUpperCase() === normalizedId &&
			item.id !== currentId
	);

	if (isDuplicate) {
		return 'Employee ID already exists.';
	}

	return '';
}



function fNameError(name: string) {
	if (!name.trim()) {
		return 'Firstname is required';
	}
	if (name.length < 3) {
		return 'Firstname must contain at least 3 characters';
	}
	if (name.length > 50) {
		return 'Firstname should be below 50 characters';
	}

	const validNameRegex = /^[a-zA-Z-]+$/;
	if (!validNameRegex.test(name)) {
		return 'Firstname should contain only letters or hyphens (no spaces)';
	}

	return '';
}

export default fNameError;

export function designationError(name: string) {
	if (!name.trim()) {
		return 'Designation is required';
	}

	if (name.trim().length < 3) {
		return 'Designation must contain at least 3 characters';
	}

	if (name.length > 50) {
		return 'Designation should be below 50 characters';
	}

	// Allowed: letters, numbers, space, dot, #, /, &, -
	const validNameRegex = /^[a-zA-Z0-9 .#/&-]+$/;

	if (!validNameRegex.test(name)) {
		return 'Designation contains invalid characters';
	}

	return '';
}


export function lNameError(name: string) {
	if (!name.trim()) {
		return 'Lastname is required';
	}
	if (name.length < 3) {
		return 'Lastname must contain at least 3 characters';
	}
	if (name.length > 50) {
		return 'Lastname should be below 50 characters';
	}

	const validNameRegex = /^[a-zA-Z-]+$/;
	if (!validNameRegex.test(name)) {
		return 'LastName should contain only letters or hyphens (no spaces)';
	}

	return '';
}
export function emailErrors(email: string) {
	if (!email.trim()) {
		return 'Email is required';
	}
	if (email.length > 125) {
		return 'Please insert an email below 125 characters';
	}
	const emailRegex = /^[a-zA-Z0-9](?!.*?[_.]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	if (!emailRegex.test(email)) {
		return 'Invalid Email Address';
	}

	return '';
}

export function phoneErrors(phone: string) {
	if (!phone) {
		return 'Phone number is required';
	}
	// Regular expression for phone number:
	// - Optional country code (e.g., +1, +91)
	// - Digits, optional spaces, hyphens, or parentheses
	// - At least 7 digits, up to 15 digits
	if (!phone.match(/^\+?[1-9]\d{0,2}[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,4}$/)) {
		return 'Invalid phone number format';
	}
	// Remove non-digit characters to check length of actual digits
	const digitCount = phone.replace(/[^0-9]/g, '').length;
	if (digitCount !== 10) {
		return 'Phone number must be 10 digits';
	}
	return '';
}
export function passwordErrors(password: string) {
	if (password.length < 8) {
		return 'Password must be at least 8 characters long.';
	}
	if (!/[A-Z]/.test(password)) {
		return 'Password must contain at least one uppercase letter.';
	}
	if (!/[a-z]/.test(password)) {
		return 'Password must contain at least one lowercase letter.';
	}
	if (!/[0-9]/.test(password)) {
		return 'Password must contain at least one number.';
	}
	if (!/[^A-Za-z0-9\s]/.test(password)) {
		return 'Password must contain at least one special character.';
	}
	if (password.length > 16) {
		return 'Password can not be max 16 characters long';
	}
	return '';
}

export function fullName(name: string) {
	if (!name.trim()) {
		return 'Fullname is required';
	}
	if (name.length < 3) {
		return 'Fullname must be at least 3 characters long';
	}
	if (name.length > 50) {
		return 'Fullname should be below 50 characters';
	}
	const validNameRegex = /^(?=.*[a-zA-Z])[a-zA-Z\s-]+$/;
	if (!validNameRegex.test(name)) {
		return 'Fullname should contain only letters, spaces, or hyphens';
	}

	return '';
}

export function currencyError(value: string) {
	if (!value.trim()) {
		return 'Amount is required';
	}

	// Remove commas for easier validation
	const numericValue = value.replace(/,/g, '');

	// Check for valid number format with up to 2 decimal places
	const validCurrencyRegex = /^\d+(\.\d{1,2})?$/;
	if (!validCurrencyRegex.test(numericValue)) {
		return 'Amount must be a valid number (up to two decimal places)';
	}

	// Optional: convert to float and validate limits
	// const floatValue = parseFloat(numericValue);
	// if (floatValue < 0.01) {
	// 	return 'Amount should be at least 0.01';
	// }
	// if (floatValue > 1000000) {
	// 	return 'Amount should not exceed 1,000,000';
	// }

	return '';
}
export function joiningDateError(dateStr: string) {
	if (!dateStr.trim()) {
		return 'Joining date is required';
	}

	const date = new Date(dateStr);
	const now = new Date();
	now.setHours(0, 0, 0, 0); // Ignore time

	// if (isNaN(date.getTime())) {
	// 	return 'Invalid date format';
	// }

	if (date < now) {
		return 'Joining date cannot be in the past';
	}

	return '';
}

export function roundType(name: string) {
	const trimmed = name.trim();

	if (!trimmed) {
		return 'RoundType is required';
	}

	if (trimmed.length < 3) {
		return 'RoundType must contain at least 3 characters';
	}

	if (trimmed.length > 50) {
		return 'RoundType should be below 50 characters';
	}

	// Disallow only numbers or only hyphens
	if (/^[\d-]+$/.test(trimmed)) {
		return 'RoundType cannot be only numbers or hyphens';
	}

	// Allow letters, numbers, single space or hyphen between words
	const validPattern = /^(?!.*[-\s]{2,})[A-Za-z0-9]+([ -][A-Za-z0-9]+)*$/;

	if (!validPattern.test(trimmed)) {
		return 'RoundType can contain letters, numbers, single spaces or hyphens only';
	}

	return '';
}
